import React,{Component} from 'react'
import List from '../../components/List'
import AliceCarousel from 'react-alice-carousel';
import {imageList} from '../CompanyLogos'

const responsive = {
    0: {
        items: 2
    },
    320: {
        items: 2
    },
    550:{
        items: 3
    },
    768: {
        items: 4
    },
    1024: {
        items: 4
    },
    1260: {
        items: 5
    },
    1460: {
        items: 5
    },
    3000:{
        items:5
    }
};

export class LogoSliderComponent extends React.Component{
    galleryItems(){
        return (imageList.map(item=><li><img src={item}/></li>))
    }
    render(){
        return <div className={'company-logos'}>
            <AliceCarousel autoPlay={true} autoPlayInterval={2500} duration={400} responsive={responsive}  items={this.galleryItems()}/>
        </div>
    }
}


class ListItem extends Component{
    render(){
        const {name,image,sub_title,description,url,highlight} = this.props.itemData
        return <li className={highlight ? 'highlight' : ''}>
            <div className={'list'}>
                <img src={image}/>
                <div className={'info'}>
                    <div className={'title'}>{name}</div>
                    <div className={'sub_title'}>{sub_title}</div>
                    <div className={'des'}>{description}</div>
                </div>
            </div>
        </li>
    }
}

export default class MainPage extends Component{
    render(){
        const {landing_image,about,aboutPara,infoList} = this.props.data
        return <div className={'main-page fit-pages'}>
            <div className={'landing-page'}>
                <div className={'info'}>
                    <div className={'head'}>The only digital transformation
                        that your sales team will ever need.</div>
{/*
                    <div className={'para'}>Empower your team with Sales Apps.</div>
*/}
                </div>
                <img src={landing_image}/>
            </div>
            <div className={'products'}>
                <LogoSliderComponent/>
            </div>
            <div className={'details'}>
                <div className={'head'}>{about}</div>
                <div className={'para'}>{aboutPara}</div>
            </div>
            <List items={infoList} listItem={ListItem} className={'info-list-cls'}/>
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/components/fit_mini_portal/mainPage.js